/* eslint-disable react-hooks/exhaustive-deps */
import {useState, useEffect} from 'react'
import {KTSVG, QueryState, useDebounce} from '../../_metronic/helpers'
import {FilterFieldProps} from './Filter'

type Props = {
  updateState: (updates: Partial<QueryState>) => void
  searchFilters?: FilterFieldProps[]
  title: string
  searchAble?: boolean
  searchFields?: string[]
}

export const SearchComponent = ({updateState, searchFilters, title, searchAble = true, searchFields}: Props) => {
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [filterValue, setFilter] = useState<any>({})
  const debouncedSearchTerm = useDebounce(searchTerm, 150)

  useEffect(() => {
    if (debouncedSearchTerm) {
      updateState({search: debouncedSearchTerm, search_fields: searchFields})
    } else if (debouncedSearchTerm === '') {
      updateState({search: undefined, search_fields: undefined})
    }
  }, [debouncedSearchTerm])

  useEffect(() => {
    updateState({filter: filterValue})
  }, [filterValue])

  return (
    <div className='font-semibold text-gray-700 mb-2'>
      {/* begin::Search */}
      <div className='flex items-center relative'>
        <div className='relative flex flex-wrap gap-4'>
          {searchAble && (
            <>
              <div className='absolute top-1/2 -translate-y-1/2 right-3'>
                <KTSVG
                  path='/media/icons/duotune/general/gen021.svg'
                  className='w-4 h-4 absolute left-2 top-1/2 -translate-y-1/2'
                />
              </div>
              <input
                type='text'
                className='form-input w-[250px] pl-10 pr-4 py-2 rounded-md border border-gray-300 bg-gray-100 text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-primary'
                placeholder={`Search ${title}`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </>
          )}

          {searchFilters?.map((filter, index) =>
            filter.type === 'date' ? (
              <input
                key={index}
                type='date'
                className='form-input w-[250px] pl-4 pr-4 py-2 rounded-md border border-gray-300 bg-gray-100 text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-primary'
                onChange={(e) => setFilter({...filterValue, [filter.name]: e.target.value})}
              />
            ) : (
              <select
                key={index}
                className='form-select w-[250px] pl-4 pr-4 py-2 rounded-md border border-gray-300 bg-gray-100 text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-primary'
                onChange={(e) => setFilter({...filterValue, [filter.name]: e.target.value})}
              >
                {/* Add options dynamically as needed */}
              </select>
            )
          )}
        </div>
      </div>
      {/* end::Search */}
    </div>
  )
}
